import {
  Form,
  Slider,
  Select,
  Radio,
  Collapse,
  InputNumber,
  Row,
  Col,
} from "antd";
import { ColorPickerFormItem } from "../Image/ImageConf";
import { useEditorContext } from "../EditorContext";
import { useThrottleFn } from "ahooks";
import ImageUpploadField from "../WechatTextImage/ImageUploadField";
import ContentPadding from "../ContentConfig/ContentPadding";
import ContentMargin from "../ContentConfig/ContentMargin";
import { DEF_FONTS } from "../constanst";
import FormBaseStyle from "../FormText/FormBaseStyle";

const DEFAULT_SETTING = {
  contentAreaWidth: 600,
  contentAreaWidthMode: "pixel",
  contentAreaWidthPercentage: 100,
  contentAreaAlignment: "center",
  defultFont: "arial",
};

const Panel = Collapse.Panel;

export default () => {
  const [form] = Form.useForm();
  const { shareRefs } = useEditorContext();

  const { run: handleSettingChange } = useThrottleFn(
    (_, data) => {
      setTimeout(() => {
        form.validateFields().then(() => {
          shareRefs.updateRows(data);
        });
      });
    },
    { wait: 200 }
  );

  return (
    <Form
      form={form}
      initialValues={{
        ...DEFAULT_SETTING,
        ...shareRefs.tree.root.data,
      }}
      onFinish={(values) => {
        Object.assign(shareRefs.tree.root.data, values);
        handleSettingChange(null, values);
      }}
      onValuesChange={(val) => {
        Object.assign(shareRefs.tree.root.data, val);
        handleSettingChange(val);
      }}
      layout="vertical"
      className="config-form"
    >
      <Collapse
        expandIconPosition="end"
        defaultActiveKey={["content", "sideImage"]}
      >
        <Panel header="Content" key="content">
          <Form.Item label="Width" name="contentAreaWidth">
            <Slider
              style={{ width: "90%" }}
              min={400}
              max={1000}
              step={5}
              marks={{ 400: "-", 1000: "+" }}
            />
          </Form.Item>
          <Form.Item label={"Default font"} name={"defultFont"}>
            <Select showSearch options={DEF_FONTS} />
          </Form.Item>
          <Row gutter={8}>
            <Col span={12}>
              <Form.Item name="shadowBlur" label="Shadow blur">
                <InputNumber
                  defaultValue={0}
                  min={0}
                  max={100}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <ColorPickerFormItem
                label={"Shadow color"}
                name="shadowColor"
                color={shareRefs.tree.root.data.shadowColor}
              />
            </Col>
          </Row>
          <ColorPickerFormItem
            label={"Background color"}
            name="backgroundColor"
            color={shareRefs.tree.root.data.backgroundColor}
          />
          <ColorPickerFormItem
            label={"Content area background color"}
            name="contentAreaBackgroundColor"
            color={shareRefs.tree.root.data.contentAreaBackgroundColor}
          />
          <ContentMargin />
          <ContentPadding />
        </Panel>
        <Panel header="Side image" key="sideImage">
          <Form.Item label="Side image" name={"sideImage"}>
            <Radio.Group buttonStyle="solid">
              <Radio.Button value="">No image</Radio.Button>
              <Radio.Button value="leftImage">Left image</Radio.Button>
              <Radio.Button value="rightImage">Right image</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const sideImage = getFieldValue("sideImage");
              if (sideImage === "leftImage" || sideImage === "rightImage") {
                return (
                  <>
                    <ImageUpploadField
                      name="sideImageUrl"
                      label="Side image"
                      rules={[{ required: true }]}
                    />
                    <div style={{ display: "flex", gap: 10, justifyContent: "space-between" }} >
                      <label>Hide on mobile</label>
                      <Form.Item noStyle name={"hideOnMobile"}>
                        <Radio.Group size="small" buttonStyle="solid">
                          <Radio.Button value="on">ON</Radio.Button>
                          <Radio.Button value="off">OFF</Radio.Button>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                    <Form.Item label="Image size" name={"sideImageSize"}>
                      <Select
                        defaultValue={"medium"}
                        options={[
                          { label: "Small", value: "small" },
                          { label: "Medium", value: "medium" },
                          { label: "Large", value: "large" },
                        ]}
                      />
                    </Form.Item>
                    <Form.Item label="Verticle align" name={"sideContentVerticleAlignment"}>
                      <Select
                        defaultValue={"medium"}
                        options={[
                          { label: "Top", value: "start" },
                          { label: "Center", value: "center" },
                          { label: "Bottom", value: "end" },
                        ]}
                      />
                    </Form.Item>
                    <Row gutter={8}>
                      <Col span={12}>
                        <Form.Item name="shadowBlur" label="Shadow blur">
                          <InputNumber
                            defaultValue={0}
                            min={0}
                            max={100}
                            style={{ width: "100%" }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <ColorPickerFormItem
                          label={"Shadow color"}
                          name="shadowColor"
                          color={shareRefs.tree.root.data.shadowColor}
                        />
                      </Col>
                    </Row>
                  </>
                );
              }
              return null;
            }}
          </Form.Item>
        </Panel>
        <Panel header="Form style" key="form-style">
          <FormBaseStyle node={shareRefs.tree.root}/>
        </Panel>
      </Collapse>
    </Form>
  );
};
